var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrettyTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.144,
    viewBox: "0 0 18 14.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pretty_TV",
    "data-name": "Pretty TV",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9012",
    "data-name": "Path 9012",
    d: "M20,6.929v7.714a1.929,1.929,0,0,1-1.929,1.929H15.629l-1-1.286h3.446a.643.643,0,0,0,.643-.643V6.929a.643.643,0,0,0-.643-.643H3.929a.643.643,0,0,0-.643.643v7.714a.643.643,0,0,0,.643.643H7.374l-1,1.286H3.929A1.929,1.929,0,0,1,2,14.643V6.929A1.929,1.929,0,0,1,3.929,5H18.072A1.929,1.929,0,0,1,20,6.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9013",
    "data-name": "Path 9013",
    d: "M18.285,22.617a.913.913,0,0,0,0-.129v-.116a.913.913,0,0,0,0-.129.643.643,0,0,0-.064-.116.091.091,0,0,0-.032-.071l-4.5-5.786a.521.521,0,0,0-.064-.058.418.418,0,0,0-.051-.058h-.039l-.116-.058a.411.411,0,0,0-.116-.039h-.244a.411.411,0,0,0-.116.039.489.489,0,0,0-.116.058h-.039a.418.418,0,0,0-.051.058.521.521,0,0,0-.064.058l-4.5,5.786a.1.1,0,0,1-.032.071.643.643,0,0,0-.064.116.913.913,0,0,0,0,.129L8,22.45v.039a.913.913,0,0,0,0,.129.816.816,0,0,0,.039.116.457.457,0,0,0,.064.09.347.347,0,0,0,.09.1.064.064,0,0,0,0,.032l.09.051.071.039a.739.739,0,0,0,.289.045h9a.739.739,0,0,0,.231-.045l.071-.039.09-.051a.064.064,0,0,0,0-.032.347.347,0,0,0,.09-.1.456.456,0,0,0,.064-.09.817.817,0,0,0,.1-.116Zm-5.143-4.905,3.214,4.1H9.992Z",
    transform: "translate(-2.142 -3.95)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrettyTv);
export default __webpack_public_path__ + "static/media/Pretty-TV.525119718a3850190c15c001b9834bab.svg";
export { ForwardRef as ReactComponent };